const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

const isStaging =
  typeof window !== "undefined" && window.location.hostname.includes("staging");
const isDev =
  typeof window !== "undefined" && window.location.hostname.includes("dev");

export const logger = {
  log: (...args) => {
    if (isLocalhost || isDev || isStaging) {
      console.log(...args);
    }
  },
  error: (...args) => {
    if (isLocalhost || isDev || isStaging) {
      console.error(...args);
    }
  },
  warn: (...args) => {
    if (isLocalhost || isDev || isStaging) {
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (isLocalhost || isDev || isStaging) {
      console.info(...args);
    }
  },
  debug: (...args) => {
    if (isLocalhost || isDev || isStaging) {
      console.debug(...args);
    }
  },
};

export default logger;
